<template>
<v-app>
  <contact-form
    :name="name"
    :authentication-token="authenticationToken"
    :required-fields="requiredFields"
    buttonText="Jetzt anmelden">
      <contact-logged-in></contact-logged-in>
      <contact-fields-events :exclude="exclude"></contact-fields-events>
  </contact-form>
</v-app>
</template>

<script>
import ContactForm from "./ContactForm";
import ContactFieldsEvents from "./ContactFieldsEvents";
import ContactLoggedIn from "../immoapp/contact/ContactLoggedIn";

export default {
  name: "EventsContactFormApp",

  components: {
    ContactForm,
    ContactFieldsEvents,
    ContactLoggedIn
  },

  data() {
    return {
      name: "events"
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    },

    authenticationToken() {
      if (this.$store && this.$store.state) {
        return this.$store.state.auth.authenticationToken;
      }

      return null;
    },

    loggedIn() {
      if (this.$store && this.$store.state) {
        return this.$store.state.user.loggedIn;
      }

      return false;
    },

    exclude() {
      let ignoreFields = [];
      if (this.loggedIn) {
        ignoreFields = ["email"];
      }

      let el = [];
      if (this.$root.exclude) {
        el = this.root.exclude;
      }

      return ignoreFields.concat(el);
    }
  }
};
</script>
